import LabelIcon from "@mui/icons-material/Label";

import PfaActionMenuItem from "./PfaActionMenuItem";

const PfaRelabelAction = ({ file }) => {
  return <PfaActionMenuItem file={file} Icon={LabelIcon} label="Relabel" />;
};

export default PfaRelabelAction;
